/**
 * Match backend _normalize_orcid (main/tasks.py): strip URL prefix, trim.
 */
export function normalizeOrcid(raw) {
  let s = (raw ?? "").toString().trim();
  if (!s) return "";
  s = s.replace("https://orcid.org/", "").replace("http://orcid.org/", "");
  return s.trim();
}

/**
 * Prefer Google Scholar when present; else ORCID profile; else none.
 */
export function getResearchPageSpec(professor) {
  const gid = (professor?.gscholarID ?? "").toString().trim();
  if (gid) {
    return {
      type: "scholar",
      href: `https://scholar.google.com/citations?hl=en&user=${encodeURIComponent(gid)}`,
      label: "Google Scholar",
    };
  }
  const oid = normalizeOrcid(professor?.orcid);
  if (oid) {
    return {
      type: "orcid",
      href: `https://orcid.org/${encodeURIComponent(oid)}`,
      label: "View Research",
    };
  }
  return { type: "none" };
}
